export default __webpack_public_path__ + "static/ve-d5e003b6485a4124cc3415adc29421a1.svg";